export enum PlannedDateValidationResult {
	Success = 1,
    InvalidPlannedDate = 2,
	InvalidLeftDuration = 3,
}